import {EventEmitter, Injectable} from '@angular/core';


class CollapsableOptions {
    code: string;
    group: string = 'none';
}

@Injectable({
    providedIn: 'root'
})
export class CollapsableService {

    public isCollapsed: EventEmitter<CollapsableOptions> =  new EventEmitter<CollapsableOptions>();
}
